import { shipmentApiClient } from '../shipmentApiClient'
import { getDeliveryWorkTypeSettingsEndpoint } from './endpoint'
import type { GetDeliveryWorkTypeSettingsResponse } from './type'

export const getDeliveryWorkTypeSettings = async (deliveryReportUid: string) => {
  const { data } = await shipmentApiClient.get<GetDeliveryWorkTypeSettingsResponse>(
    getDeliveryWorkTypeSettingsEndpoint(deliveryReportUid)
  )
  return data
}
